/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import React, { useContext, useState, useEffect } from 'react';
import { Autocomplete, TextField, Box, Button } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import Grid from '@mui/material/Unstable_Grid2';
import moment from 'moment';
import { toast } from 'react-toastify';

// Context
import useFootprintContext from '../context/useFootprintContext';

export default function Filter() {
  const { filterForm, setFilterForm, handleGenerateFilter, handleClearFilter } =
    useContext(useFootprintContext);

  const footprintOptions = [
    { label: 'ALL', value: null },
    { label: 'Field Engagement', value: 'field_engagement' },
    { label: 'Client Call Out', value: 'client_call_out' },
  ];

  const handleChangeFilter = (e, row, name) => {
    setFilterForm({ ...filterForm, [name]: row });
  };

  const handleChangeDate = (value, name) => {
    if (name === 'date_from') {
      setFilterForm({
        ...filterForm,
        date_from: moment(value).format('YYYY-MM-DD'),
        date_to: moment(value).endOf('month').format('YYYY-MM-DD'),
      });
    }

    if (name === 'date_to') {
      if (moment(value).format('M') !== moment(filterForm?.date_from).format('M')) {
        toast.warning('Please select date with same month..');
        return;
      }
      setFilterForm({
        ...filterForm,
        date_to: moment(value).format('YYYY-MM-DD'),
      });
    }
  };

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid md={2}>
          <Autocomplete
            disablePortal
            id='engagement'
            disableClearable
            fullWidth
            options={footprintOptions}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField {...params} label='Engagement' />}
            size='small'
            value={filterForm?.type}
            onChange={(e, newValue) => handleChangeFilter(e, newValue, 'type')}
            sx={{ backgroundColor: '#fff' }}
          />
        </Grid>

        <Grid md={1.5}>
          <DesktopDatePicker
            label='Date From'
            inputFormat='MM/DD/YYYY'
            value={filterForm.date_from}
            onChange={(e) => handleChangeDate(e, 'date_from')}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} fullWidth />}
          />
        </Grid>
        <Grid md={1.5}>
          <DesktopDatePicker
            label='Date To'
            inputFormat='MM/DD/YYYY'
            value={filterForm?.date_to}
            onChange={(e) => handleChangeDate(e, 'date_to')}
            // eslint-disable-next-line react/jsx-props-no-spreading
            renderInput={(params) => <TextField size='small' {...params} fullWidth />}
          />
        </Grid>
        <Grid md={2}>
          <Button variant='contained' color='success' onClick={() => handleGenerateFilter()}>
            Generate
          </Button>
          <Button
            variant='contained'
            color='primary'
            onClick={() => handleClearFilter()}
            sx={{ marginLeft: '10px' }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
